import { render } from "./ListEvents.vue?vue&type=template&id=3a5e3112&scoped=true"
import script from "./ListEvents.vue?vue&type=script&lang=js"
export * from "./ListEvents.vue?vue&type=script&lang=js"

import "./ListEvents.vue?vue&type=style&index=0&id=3a5e3112&scoped=true&lang=css"

import exportComponent from "/webserver/websites/dev/intrapaf-v2-public-client-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5e3112"]])

export default __exports__